module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Add"
  }, [_c('div', {
    staticClass: "row row1 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian"
  }), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "row row2 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin))])]), _vm._v(" "), _c('div', {
    staticClass: "waypoint"
  }, _vm._l((_vm.waypoint), function(item, index) {
    return _c('div', {
      staticClass: "row clear",
      class: item.arrive ? 'arrive' : ''
    }, [_c('i', {
      staticClass: "iconfont icon-yuan1"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.address))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row row3 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.endPoint))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55fb41e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/add/src/add.vue
// module id = 533
// module chunks = 0